import { BASE_RENTAL_SLUGS, SLUG_NORMALIZATION_MAP } from 'app/shared/constants/SlugMappingConstants';

/**
 * Normalizes a search slug to its base rental equivalent
 * @param slug - The current search slug
 * @returns The normalized slug (apartments-for-rent, houses-for-rent, or original slug if no mapping exists)
 */
export const normalizeSlugToBaseRental = (slug: string): string => {
  // If it's already a base slug, return it as-is
  if (slug === BASE_RENTAL_SLUGS.APARTMENTS || slug === BASE_RENTAL_SLUGS.HOUSES) {
    return slug;
  }

  // Otherwise, normalize using the mapping or default to apartments
  return SLUG_NORMALIZATION_MAP[slug as keyof typeof SLUG_NORMALIZATION_MAP] || BASE_RENTAL_SLUGS.APARTMENTS;
};

/**
 * Checks if a slug should be normalized (exists in the mapping)
 * @param slug - The search slug to check
 * @returns True if the slug has a normalization mapping
 */
export const shouldNormalizeSlug = (slug: string): boolean => {
  return slug in SLUG_NORMALIZATION_MAP;
};
